import { Injectable } from '@angular/core';

@Injectable()
export class ShiftHelper {

  transformShiftNumber(index: number) {
    return index === 0 ? 'I' : index === 1 ? 'II' : 'III';
  }
}
